import PropTypes from 'prop-types';
import React from 'react';

import IconButton from './IconButton';

const SettingsNavCell = ({title, onClick}) => (
  <div className="SettingsNavCell">
    <p className="SettingsNavCell__title">
      {title}
    </p>
    <IconButton
      styleName="SettingsNavCell__button"
      onClick={() => onClick()}
    />
  </div>
);

SettingsNavCell.propTypes = {
  title: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
};

export default SettingsNavCell;



// WEBPACK FOOTER //
// ./src/components/SettingsNavCell.js